import { getRentAssist, getSingleCownProperty, getSingleProperty, postBookInspection } from '../services/userService';
import { useRef, useState } from 'react';
import { User } from '../../Storeredux/constants/actionTypes';
import { BookInspection, ObjectType } from '../constant/serviceType';
import { useToast } from '../../Store/NotificationContext';

export const useSingleProperty = ( ) => {
  const [propertyDetails, setPropertyDetails] = useState<User>();
  const [loading, setLoading] = useState<boolean>(false);
  const { showToast } = useToast();
  const didFetch = useRef<boolean>(false);
  const getSinglePropertyData = async (id: string | number, data: { user_id: string }) => {
    if (didFetch.current) return;
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getSingleProperty(id, data);
      console.log('SINGLE PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setPropertyDetails(userResponse);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e.response.data.message);
      setLoading(false);
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };

  const getSingleCoownPropertyData = async (id: string | number) => {
    if (didFetch.current) return;
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getSingleCownProperty(id);
      console.log('SINGLE PROPERTY', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setPropertyDetails(userResponse);
        setLoading(false);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      console.log(e.response.data.message);
      setLoading(false);
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };

  const BookPropertyInspection = async (payload: BookInspection) => {
    let userResponse = null;
    setLoading(true);
    try {
      const response = await postBookInspection(payload);
      console.log('SINGLE PROPERTY', response);
      userResponse = response?.data;
      if (userResponse) {
        setLoading(false);
        showToast('Success', 'Successfully booked inspection', 'success');
        // eslint-disable-next-line @typescript-eslint/naming-convention
        return { success: true };
      }
    } catch (e: any) {
      setLoading(false);
      showToast('Error', e.response.data.message, 'error');
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };

  const requestAssist = async (payload: ObjectType) => {
    let userResponse = null;
    setLoading(true);
    try {
      const response = await getRentAssist(payload);
      console.log('rent assist', response);
      userResponse = response?.data?.data;
      if (userResponse) {
        setLoading(false);
        showToast('Success', 'Successfully Requested Rent', 'success');
        return { success: true, link: userResponse.link };
      }
    } catch (e: any) {
      setLoading(false);
      showToast('Error', e.response.data.message, 'error');
      return { success: false, error: e.response.data.message };
    }

    return userResponse;
  };


  return { getSinglePropertyData, getSingleCoownPropertyData, loading, propertyDetails, BookPropertyInspection,
    requestAssist };
};
